import { Record } from 'immutable';
import { ConfigLookupType } from './config-lookup-type';
import { PropertyConfigLookup } from './property-config-lookup';
import { AgencyConfigLookup } from './agency-config-lookup';

const ConfigRequestRecord = Record({
  config: null,
  property: null,
  agency: null
});

export class ConfigRequest extends ConfigRequestRecord {
  config: ConfigLookupType;
  property: PropertyConfigLookup;
  agency: AgencyConfigLookup;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/config/config-request.ts